import { useState, useEffect } from "react";
import { Circle } from "rc-progress";
import ColorSchema from "../Color";
import { ProgressBar as ReactProgressBar } from "react-bootstrap";
import "./progress-bar.scss";

export default function ProgressBar({
  progressbarShow,
  total,
  done,
  color = ColorSchema.success_custom,
  width = 10,
  circleWidth = 50,
  circleHeight = 50,
  description,
  type = "line",
}) {
  const circleProgress = (
    <>
      {" "}
      <Circle
        percent={(done / total) * 100}
        strokeWidth={width}
        strokeColor={color}
      />
      <div
        className="position-absolute"
        style={{ top: 20, right: 7, fontSize: 11 }}
      >
        <span className="px-1">{done}</span>
        <span>از {total}</span>
      </div>
      <div style={{ fontSize: 14 }}>{description}</div>
    </>
  );

  const lineProgress = (
    <div
      className="shadow"
      style={{
        height: "95%",
        width: "95%",
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        border: `1px solid ${ColorSchema.dark_light_custom}`,
      }}
    >
      {" "}
      <div
        className=" h-100 d-flex flex-column"
        style={{
          backgroundColor: ColorSchema.white_custom,
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
          // boxShadow:
          //   "0 10px 10px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
        }}
      >
        <div className="flex-grow-1 d-flex justify-content-between px-2 ">
          <span className="my-auto">
            {done} از {total}
          </span>

          <div className="my-auto description-line">{description}</div>
          <span
            style={{ color: ColorSchema.primary_custom }}
            className="my-auto"
          >
            {(done / total) * 100}%
          </span>
        </div>
        <ReactProgressBar
          now={(done / total) * 100}
          style={{
            borderRadius: 0,
            height: 6,
            backgroundColor: ColorSchema.primary_light_custom,
            direction: "ltr",
          }}
        />
      </div>
    </div>
  );
  return (
    <>
      {progressbarShow && (
        <div
          style={{ width: circleWidth, height: circleHeight }}
          className="mb-2 mx-auto position-relative progress-bar"
        >
          {type == "line" ? lineProgress : circleProgress}
        </div>
      )}
    </>
  );
}
